import { render, staticRenderFns } from "./FormCurrency.vue?vue&type=template&id=641b17ca&"
import script from "./FormCurrency.vue?vue&type=script&lang=js&"
export * from "./FormCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports